import { createInternetID } from '@noah-labs/shared-util-vanilla';
import { getConfig } from '../config';

export function getUserLnAddress(userNameDisplay: string): string {
  const { lnDomain } = getConfig();
  return createInternetID(userNameDisplay, lnDomain);
}
